<template>
    <div>
       
        <div class="row">
            <div class="col-sm-6"><h3 class="title">Broadcast Detail</h3></div>
            <div class="col-sm-6 text-right" >
                <a href="javascript:void(0);" class="btn btn-default" style="margin-bottom: 15px;" @click="onBack"><i class="fas fa-chevron-left"></i> Back</a>
            </div>
        </div>
        <div style="border: 1px solid #eee; border-radius: 10px" v-if="broadcast">
            <div class="container-fluid">
                <div class="row" style="margin-top: 30px">
                    <div class="col-sm-3">Broadcast Name</div>
                    <div class="col-sm-4" >
                        {{ name }}
                    </div>
                </div>

                <div class="row">
                    <hr>
                </div>

                <div class="row">
                    <div class="col-sm-3">Message Type</div>
                    <div class="col-sm-2" v-if="sendtype == 'subscription'">
                        Subscription
                    </div>
                    <div class="col-sm-2" v-else-if="sendtype == 'promotion'">
                        Promotion
                    </div>
                </div>

                <!-- <div class="row" v-if="sendtype == 'subscription'">
                    <div class="col-sm-9 col-sm-offset-3" style="margin-top: 15px;">
                        <div class="alert alert-warning" role="alert">Before using this feature, please apply Facebook Page Subscription Messages. <a href="https://developers.facebook.com/docs/messenger-platform/policy/app-to-page-subscriptions/" target="_blank" rel="noopener noreferrer">See How do I apply to send subscription messages?</a>
                        You cannot broadcast promotional message. Your page might be blocked by Facebook if you broadcast promotional messages or when user report that they receive too many messages. <a href="https://developers.facebook.com/docs/messenger-platform/policy/policy-overview/#subscription_messaging" target="_blank" rel="noopener noreferrer">See guideline for more information</a></div>
                    </div>
                </div>

                <div class="row" v-else>
                    <div class="col-sm-9 col-sm-offset-3" style="margin-top: 15px;">
                        <div class="alert alert-warning" role="alert">Promotion message can only reach user who had conversation with chatbot within last 24 hours.</div>
                    </div>
                </div> -->


                <div class="row">
                    <hr>
                </div>

                <div class="row">
                    <div class="col-sm-3">Notification Setting</div>
                    <div class="col-sm-2" v-if="pushtype == 'REGULAR'">
                        Regular Push 
                    </div>
                    <div class="col-sm-2" v-else-if="pushtype == 'SILENT_PUSH'">
                        Silent Push
                    </div>
                    <div class="col-sm-2" v-else-if="pushtype == 'NO_PUSH'">
                        No Push
                    </div>
                </div>
                
                <div class="row">
                    <hr>
                </div>

                <div class="row">
                    <div class="col-sm-3">Target</div>
                    <div class="col-sm-4">
                        <template v-if="groupType == ''">All</template>
                        <template v-else-if="groupType == 'male'">Male</template>
                        <template v-else-if="groupType == 'female'">Female</template>
                        <template v-else-if="groupType == 'customize'">
                            <p>Name: {{filter.fullname ? filter.fullname : '-'}}</p>
                            <p>Gender: {{filter.gender ? filter.gender : '-'}}</p>
                            <p>Locale: 
                                <template v-if="filter.locale.length > 0">
                                    <span v-for="(locale,index) in filter.locale" :key="'locale_'+ index"><flag :iso="locale.icon" /> {{locale.title}} <template v-if="index != filter.locale.length - 1">,</template></span>
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </p>
                            <p>
                                App: 
                                <span style="color: #3b5998" v-if="filter.app == 'facebook'"><i class="fab fa-facebook-square"></i> Facebook</span>
                                <span style="color: #00c300" v-else-if="filter.app == 'line'"><i class="fab fa-line"></i> Line</span>
                                <span v-else> All</span>
                            </p>
                            <p>
                                Intent: 
                                <template v-if="filter.intent.length > 0">
                                    <span v-for="(intent,index) in filter.intent" :key="'intent_'+ index">{{intent}} <template v-if="index != filter.intent.length - 1">,</template></span>
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </p>
                            <p>Email: {{filter.email ? filter.email : '-'}}</p>
                            <p>Phone No: {{filter.phoneno ? filter.phoneno : '-'}}</p>
                            <p>Message Sent: {{filter.messagesent.symbol == 'g__' ? 'Greater than' : (filter.messagesent.symbol == 'l__' ? 'Less than' : 'Not')}} {{filter.messagesent.value}}</p>
                            <p>
                                First Conversation At: {{filter.registerDate.start | DateFormat('DD/MM/YYYY')}} - {{filter.registerDate.end | DateFormat('DD/MM/YYYY')}}
                            </p>
                            <p>
                                Last Conversation At: {{filter.activeDate.start | DateFormat('DD/MM/YYYY')}} - {{filter.activeDate.end | DateFormat('DD/MM/YYYY')}}
                            </p>
                        </template>
                        
                        
                    </div>
                </div>

                
                <div class="row">
                    <hr>
                </div>

                <div class="row">
                    <div class="col-xs-12">
                        <template v-if="type == 'text'">
                            <div>
                                <message-viewer v-model="message" style="float: left"></message-viewer>
                            </div>
                            <div class="clearfix"></div>
                        </template>
                        <template v-else-if="type == 'template'">
                            <generic-viewer v-model="generics" style="float: left"></generic-viewer>				
                            <div class="clearfix"></div>
                        </template>
                        <br>
                    </div>
                </div>
            </div>
            <hr>
            <div class="text-center">
                <a href="javascript:void(0);" class="btn btn-default" style="margin-bottom: 15px;" @click="onBack"><i class="fas fa-chevron-left"></i> Back</a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from "moment";
import config from '@/config'
import GenericViewer from '@/components/elements/GenericViewer'
import MessageViewer from '@/components/elements/MessageViewer'
import api from '@/api'

    export default {
        props: ['value'],
        data: function(){
            return {
                broadcast: undefined,
                isSave: false,
                isFail: false,
                name: '',
                localeOptions: config.locale,
                intents: [],
                type: 'text',
                groupType: '',
                sendtype: 'subscription',
                pushtype: 'regular',
                message: '',
                quick_reply: '',
                typeOptions: [
                    {
                        'value' : 'text',
                        'name' : 'Text'
                    },
                    {
                        'value' : 'template',
                        'name' : 'Generic' 
                    }
                ],
                generics: [
                    {
                        image_url: null,
                        title: '',
                        subtitle: '',
                        buttons: [],

                        enable: true
                    },
                ],
                filter: {
                    fullname: "",
                    gender: 'all',
                    locale: null,
                    app: 'all',
                    intent: null,
                    email: "",
                    phoneno: "",
                    messagesent: {
                        value: null,
                        symbol: 'g__',
                    },
                    timezone: {
                        from: -12,
                        to: 14,
                    },
                    activeDate: {
                        enable: false,
                        start: moment().toDate(),
                        end: moment().toDate()
                    },
                    registerDate: {
                        enable: false,
                        start: null,
                        end: null
                    }
                }
            }
        },
        components: {
            GenericViewer,
            MessageViewer,
        },
        mounted: function(){
            var vm = this
            vm.getIntent(function(){
                
            })

            if (vm.value) {
                vm.broadcast = Object.assign({},vm.value)
                vm.cached_broadcast = Object.assign({},vm.value)    

                var filters = vm.broadcast.m_condition.split('&')
                // console.log(filters)
                if (filters.length > 0) { 
                    if (filters.length > 1) {
                        vm.groupType = 'customize'
                    } else {
                        var value = filters[0].split(/=(.+)/)
                        if (value.length > 1 && value[0] == 'gender') {
                            vm.groupType = value[1]
                        }
                        
                    } 
                    $.each(filters,function(index, filter){
                        var value = filter.split(/=(.+)/)
                        if (value.length > 1) {
                            // console.log(value)
                            switch (value[0]) {
                                case 'fullname':
                                case 'gender':
                                case 'app':
                                case 'email':
                                case 'status':
                                case 'phoneno':
                                    vm.filter[value[0]] = value[1]
                                    break;
                                case 'messagesent':
                                    var messagesent = value[1].split('__')
                                    vm.filter[value[0]] = {
                                        value : messagesent[1],
                                        symbol : messagesent[0] + '__'
                                    }
                                    break;
                                case 'locale':
                                    var locales = value[1].split(',')
                                    vm.filter.locale = []
                                    $.each(locales,function(lindex, locale){
                                        $.each(vm.localeOptions,function(clindex, config_local){
                                            if (config_local.value == locale) {
                                                vm.filter.locale.push(config_local)
                                                return false
                                            }
                                        })
                                    })
                                    break;
                                case 'intent':
                                    vm.filter.intent = value[1].split(',')
                                    break;
                                case 'timestamp_from': 
                                    vm.filter.activeDate.start = moment(value[1]).toDate()
                                    break;
                                case 'timestamp_to': 
                                    vm.filter.activeDate.end = moment(value[1]).toDate()
                                    break;
                                case 'registertimestamp_from': 
                                    vm.filter.registerDate.start = moment(value[1]).toDate()
                                    break;
                                case 'registertimestamp_to': 
                                    vm.filter.registerDate.end = moment(value[1]).toDate()
                                    break;
                            }
                        }
                    })
                }

                vm.name = vm.broadcast.name
                vm.type = vm.broadcast.m_type
                vm.quick_reply = vm.broadcast.m_quick_reply
                vm.sendtype = vm.broadcast.sendtype
                vm.pushtype = vm.broadcast.pushtype

                if(vm.type == 'template'){
                    vm.generics = JSON.parse(vm.broadcast.m_val)
                }  else {
                    vm.message = vm.broadcast.m_val
                }
                
            } else {
                vm.broadcast = {
                    m_condition: null,
                    name: null,
                    m_type: null,
                    m_quick_reply: null,
                    m_val: null,
                }
            }
        },
        computed: {
            ...mapGetters({
                selectedBot: 'selectedBot',
            }),
            filterIntent: function(){
                var vm = this
                vm.intents.sort(function(a, b) {
                    var nameA = a.intentname.toUpperCase(); // ignore upper and lowercase
                    var nameB = b.intentname.toUpperCase(); // ignore upper and lowercase
                    if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
                        return 1;
                    }
                    if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
                        return -1;
                    }
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }

                    // names must be equal
                    return 0;
                });
                var intents = []
                $.each(vm.intents ,function(index, intent){
                    intents.push(intent.intentname)
                })
                return intents
            }
        },
        methods: {
            getIntent: function(callback) {
                let vm = this
                let auth = null;
                let data = {
                    pageid : vm.selectedBot.pageid,
                }
                api.getIntent(data,function(error, response){
                    if (error) {
                        console.error(error)
                        return
                    }
                    if (response.data) {
                        var isFoundDefault = false
                        $.each(response.data,function(index, val){
                            var intent = val
                            intent.isShow = false
                            vm.intents.push(intent)
                        })
                    }
                    callback()
                })
            },
            onBack: function(){
                var vm = this
                vm.$emit('onClose')
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/broadcast/BroadcastView.vue